import React, { useState, useEffect } from 'react';
import pb from '../../services/pocketbase';
import { useAuth } from '../../context/AuthContext';
import './NotificationSystem.css';

function NotificationSystem() {
  const { user, isLoggedIn } = useAuth();
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!isLoggedIn || user?.role !== 'admin') return;

    // Écouter les nouveaux messages de contact en temps réel
    const unsubscribeContact = pb.collection('contact_messages').subscribe('*', (e) => {
      if (e.action === 'create') {
        const newNotification = {
          id: Date.now(),
          type: 'contact_message',
          title: '📧 Nouveau message de contact',
          message: `De: ${e.record.name} (${e.record.email})`,
          timestamp: new Date(),
          data: e.record
        };

        setNotifications(prev => [newNotification, ...prev.slice(0, 4)]); // Garder max 5 notifications

        // Auto-supprimer après 10 secondes
        setTimeout(() => {
          setNotifications(prev => prev.filter(n => n.id !== newNotification.id));
        }, 10000);
      }
    });

    // Écouter les nouveaux messages de chat en temps réel
    const unsubscribeChat = pb.collection('chat_messages').subscribe('*', async (e) => {
      if (e.action === 'create') {
        try {
          // Récupérer les détails de l'expéditeur
          const sender = await pb.collection('users').getOne(e.record.sender);
          
          const newNotification = {
            id: Date.now() + 1, // +1 pour éviter les conflits d'ID
            type: 'chat_message',
            title: '💬 Nouveau message de chat',
            message: `De: ${sender.name || sender.username || sender.email}`,
            timestamp: new Date(),
            data: e.record
          };

          setNotifications(prev => [newNotification, ...prev.slice(0, 4)]);

          // Auto-supprimer après 10 secondes
          setTimeout(() => {
            setNotifications(prev => prev.filter(n => n.id !== newNotification.id));
          }, 10000);
        } catch (error) {
          console.error('Erreur lors de la récupération des détails du chat:', error);
        }
      }
    });

    return () => {
      pb.collection('contact_messages').unsubscribe(unsubscribeContact);
      pb.collection('chat_messages').unsubscribe(unsubscribeChat);
    };
  }, [isLoggedIn, user]);

  const dismissNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  if (!isLoggedIn || user?.role !== 'admin' || notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-system">
      {notifications.map(notification => (
        <div key={notification.id} className="notification-toast">
          <div className="notification-content">
            <div className="notification-header">
              <span className="notification-title">{notification.title}</span>
              <button 
                className="notification-close"
                onClick={() => dismissNotification(notification.id)}
              >
                ✕
              </button>
            </div>
            <div className="notification-message">
              {notification.message}
            </div>
            <div className="notification-actions">
              <button 
                className="notification-btn primary"
                onClick={() => {
                  // Rediriger vers l'onglet approprié
                  if (notification.type === 'contact_message') {
                    window.location.hash = '#contact';
                  } else if (notification.type === 'chat_message') {
                    window.location.hash = '#messages';
                  }
                  dismissNotification(notification.id);
                }}
              >
                👀 Voir le message
              </button>
              <button 
                className="notification-btn secondary"
                onClick={() => dismissNotification(notification.id)}
              >
                Ignorer
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default NotificationSystem;
